import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const facebook: Platform = {
  id: 'facebook',
  name: 'Facebook',
  iconIndex: PlatformRegistry.facebook.index,
  color: PlatformRegistry.facebook.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.facebook.com/sharer/sharer.php', {
      u: content.url,
    });
  },
};

